module.exports = __webpack_public_path__ + "static/img/index_loop_03.33bc012.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/index_loop_03.png
// module id = A7D+
// module chunks = 1